import { render, staticRenderFns } from "./Lander.vue?vue&type=template&id=286b1587"
import script from "./Lander.vue?vue&type=script&lang=js"
export * from "./Lander.vue?vue&type=script&lang=js"
import style0 from "./Lander.vue?vue&type=style&index=0&id=286b1587&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports